enum Provider {
  smartlink = 'smartlink',
}

export default defineNuxtPlugin({
  async setup() {
    const { $api } = useNuxtApp();
    const Tournament = reactive({
      tournamentsNotificationsNumber: 0,
      tournamentTeamNotifications: 0,
      tournamentPendingRequests: 0,
      requireAuth: false,
      joiningTeam: {
        status: false,
        isLeader: false,
      },
      getNotificationAlert: async (): Promise<any> => {
        try {
          if (Tournament.tournamentsNotificationsNumber !== null) {
            return Tournament.tournamentsNotificationsNumber;
          }
          const notificationsRes: any = await $api.endPoints.getStructure(
            'fragments_tournament-team-notifications',
            {},
            undefined as any,
            true as any,
            { c: new Date().getTime() }
          );

          const pendingRes: any = await $api.endPoints.getStructure(
            'fragments_tournament-pending-requests',
            {},
            undefined as any,
            true as any,
            { c: new Date().getTime() }
          );
          if (pendingRes && pendingRes[0]?.data?.data?.length) {
            pendingRes[0]?.data?.data.forEach((team: any) => {
              Tournament.tournamentsNotificationsNumber += team.members.length;
            });
          }
          if (notificationsRes && notificationsRes[0]?.data?.data?.length) {
            Tournament.tournamentsNotificationsNumber +=
              notificationsRes[0]?.data?.data?.length || '';
            Tournament.tournamentTeamNotifications +=
              notificationsRes[0]?.data?.data?.length || '';

            return Tournament.tournamentsNotificationsNumber;
          }
        } catch (error) {
          return null;
        }
      },
      markTournamentInvitationToBeNotified: async (provider?: string): Promise<any> => {
        try {
          await $api.endPoints.markTournamentInvitationToBeNotified(
            provider || Provider.smartlink
          );
          Tournament.tournamentsNotificationsNumber -= Tournament.tournamentTeamNotifications;
        } catch (error) {
          console.error(
            'Error: failed to mark Tournament Invitation To Be Notified'
          );
        }
      },
    });
    return {
      provide: {
        tournament: Tournament,
      },
    };
  },
});
